import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

const clients = [
  // Property Developers & Owners
  { 
    name: 'Wheelock Properties',
    logo: '/assets/images/Logo_Wheelock_01.png'
  },
  { 
    name: 'Swire Properties',
    logo: '/assets/images/Logo02_Swire_properties.png'
  },
  { 
    name: 'China State Engineering Construction',
    logo: '/assets/images/Logo_CSGEC_11.jpg'
  },
  { 
    name: 'China Overseas',
    logo: '/assets/images/Logo_ChinaOversea_08.png'
  },
  { 
    name: 'MTR Corporation',
    logo: '/assets/images/Logo03_MTR_LOGO.png'
  },
  { 
    name: 'Sun Hung Kai Properties',
    logo: '/assets/images/Logo04_sun_hung_kai.png'
  },
  { 
    name: 'Jones Lang LaSalle',
    logo: '/assets/images/Logo_JLL_04.png'
  },
  { 
    name: 'Hong Kong Jockey Club',
    logo: '/assets/images/Logo_hkjc_05.png'
  },
  { 
    name: 'Sinoland',
    logo: '/assets/images/Logo01_sinoland.png'
  },
  { 
    name: 'Woo Lee',
    logo: '/assets/images/Logo_WooLee_12.png'
  },
  // Government Departments
  { 
    name: 'Architectural Services Department',
    logo: '/assets/images/Logo_HKG_Architect_01.png'
  },
  { 
    name: 'Drainage Services Department',
    logo: '/assets/images/Logo_DrainageServices_02.png'
  },
  { 
    name: 'Hong Kong Housing Authority',
    logo: '/assets/images/Logo_HKG_Hkhousing_03.png'
  },
  { 
    name: 'Water Supplies Department',
    logo: '/assets/images/Logo_HKG_WaterSupplies_04.png'
  },
  // Main Contractors & Others
  { 
    name: 'Gammon Construction',
    logo: '/assets/images/Logo_MC_Gammon_01.png'
  },
  { 
    name: 'Airport Authority',
    logo: '/assets/images/Logo_MC_airport_02.png'
  },
  { 
    name: 'Vocational Training Council',
    logo: '/assets/images/Logo_vtc_03.png'
  },
  { 
    name: 'Yau Lee Construction',
    logo: '/assets/images/Logo_yaulee_06.jpg'
  },
  { 
    name: 'Clearwater Group',
    logo: '/assets/images/Logo_clearwater_07.png'
  },
  { 
    name: 'Shui On Construction',
    logo: '/assets/images/Logo_MC_ShuiOn_03.png'
  }
];

const Clients: React.FC = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">Our Clients</h2>
          <div className="w-28 h-1 bg-[#ff2910] mx-auto mb-6"></div>
          <p className="max-w-2xl mx-auto text-xl text-gray-600">
            Hop Shing Engineering & Construction Limited has a broad base of renowned clients and customer contacts, including Main Contractors, Property Owners & Developers, and Government Departments.
          </p>
        </div>

        <div className="max-w-7xl mx-auto">
          <Swiper
            modules={[Autoplay, EffectFade]}
            spaceBetween={40}
            slidesPerView={2}
            loop={true}
            speed={1000}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              640: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 4,
              },
              1024: {
                slidesPerView: 5,
                spaceBetween: 50,
              },
            }}
            className="py-12"
          >
            {clients.map((client, index) => (
              <SwiperSlide key={index}>
                <div className="flex items-center justify-center h-32">
                  <img
                    src={client.logo}
                    alt={`${client.name} logo`}
                    className="max-w-full max-h-full object-contain transition-transform duration-500 hover:scale-110"
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default Clients;